<template>
  <!-- eslint-disable -->
  <div>
    <div class="column-left">
      <SideNav />
    </div>
    <div class="column-right">
      <TopNavClean />
      <div v-if="isLoading">
        <Loader />
      </div>
      <div class="main-container">
        <!-- Header -->
        <div class="page-header">
          <div class="header-content">
            <div class="title-section">
              <div class="page-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z"></path>
                </svg>
              </div>
              <div>
                <h1 class="page-title">Configuración del Prestador</h1>
                <p class="page-subtitle">Visualiza y gestiona la configuración completa</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="tabs-container">
          <button 
            v-for="tab in tabs" 
            :key="tab.id"
            :class="['tab-button', { active: activeTab === tab.id }]"
            @click="activeTab = tab.id"
          >
            {{ tab.label }}
          </button>
        </div>

        <!-- Assets Section -->
        <div v-if="activeTab === 'assets'" class="config-container">
          <div class="config-section">
            <h2 class="section-title">Colores de Marca</h2>
            <div class="config-card">
              <div class="colors-grid">
                <div v-for="(color, key) in prestador.atributos.assets.colors" :key="key" class="color-item">
                  <label class="field-label">{{ formatLabel(key) }}</label>
                  <div class="color-display-large">
                    <div class="color-preview" :style="{ backgroundColor: color }"></div>
                    <div class="color-info">
                      <span class="color-value">{{ color }}</span>
                      <span class="color-key">{{ key }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Config Section -->
        <div v-if="activeTab === 'config'" class="config-container">
          <div class="config-section">
            <div class="section-header">
              <h2 class="section-title">Configuraciones Generales</h2>
              <button class="toggle-keys-btn" @click="showKeys = !showKeys">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                </svg>
                {{ showKeys ? 'Ocultar' : 'Mostrar' }} Claves JSON
              </button>
            </div>
            
            <div class="config-card">
              <div class="config-fields">
                <div v-for="(value, key) in prestador.atributos.config" :key="key" class="field-item">
                  <!-- Boolean Field (0/1) -->
                  <div v-if="isBoolean(value)" class="field-row">
                    <div class="field-info">
                      <label class="field-label">{{ formatLabel(key) }}</label>
                      <span v-if="showKeys" class="field-key">{{ key }}</span>
                    </div>
                    <label class="toggle-switch">
                      <input type="checkbox" :checked="value === 1" disabled>
                      <span class="toggle-slider"></span>
                    </label>
                  </div>

                  <!-- HTML Field -->
                  <div v-else-if="isHTML(value)" class="field-column">
                    <div class="field-info">
                      <label class="field-label">{{ formatLabel(key) }}</label>
                      <span v-if="showKeys" class="field-key">{{ key }}</span>
                    </div>
                    <div class="html-editor">
                      <div class="editor-tabs">
                        <button 
                          :class="['editor-tab', { active: htmlViews[key] === 'preview' }]"
                          @click="htmlViews[key] = 'preview'"
                        >
                          Vista Previa
                        </button>
                        <button 
                          :class="['editor-tab', { active: htmlViews[key] === 'code' }]"
                          @click="htmlViews[key] = 'code'"
                        >
                          Código HTML
                        </button>
                      </div>
                      <div class="editor-content">
                        <div v-if="htmlViews[key] === 'preview'" class="html-preview" v-html="value"></div>
                        <pre v-else class="html-code">{{ value }}</pre>
                      </div>
                    </div>
                  </div>

                  <!-- Array Field -->
                  <div v-else-if="Array.isArray(value)" class="field-column">
                    <div class="field-info">
                      <label class="field-label">{{ formatLabel(key) }}</label>
                      <span v-if="showKeys" class="field-key">{{ key }}</span>
                    </div>
                    <div class="array-display">
                      <div class="array-badge">{{ value.length }} elementos</div>
                      <pre class="json-preview">{{ JSON.stringify(value, null, 2) }}</pre>
                    </div>
                  </div>

                  <!-- Object Field -->
                  <div v-else-if="typeof value === 'object' && value !== null" class="field-column">
                    <div class="field-info">
                      <label class="field-label">{{ formatLabel(key) }}</label>
                      <span v-if="showKeys" class="field-key">{{ key }}</span>
                    </div>
                    <div class="object-display">
                      <div class="object-badge">{{ Object.keys(value).length }} propiedades</div>
                      <pre class="json-preview">{{ JSON.stringify(value, null, 2) }}</pre>
                    </div>
                  </div>

                  <!-- Number Field -->
                  <div v-else-if="typeof value === 'number'" class="field-row">
                    <div class="field-info">
                      <label class="field-label">{{ formatLabel(key) }}</label>
                      <span v-if="showKeys" class="field-key">{{ key }}</span>
                    </div>
                    <div class="number-badge">{{ value }}</div>
                  </div>

                  <!-- String Field -->
                  <div v-else class="field-column">
                    <div class="field-info">
                      <label class="field-label">{{ formatLabel(key) }}</label>
                      <span v-if="showKeys" class="field-key">{{ key }}</span>
                    </div>
                    <div class="text-display">{{ value || 'Sin valor' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Info Section -->
        <div v-if="activeTab === 'info'" class="config-container">
          <div class="config-section">
            <h2 class="section-title">Información del Prestador</h2>
            <div class="config-card">
              <div class="info-grid">
                <div class="info-card">
                  <div class="info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <div class="info-content">
                    <span class="info-label">ID del Prestador</span>
                    <span class="info-value">{{ prestador.id || 'No disponible' }}</span>
                  </div>
                </div>

                <div class="info-card">
                  <div class="info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                    </svg>
                  </div>
                  <div class="info-content">
                    <span class="info-label">Total de Configuraciones</span>
                    <span class="info-value">{{ Object.keys(prestador.atributos.config || {}).length }}</span>
                  </div>
                </div>

                <div class="info-card">
                  <div class="info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z"></path>
                      <path d="M12 6v6l4 2"></path>
                    </svg>
                  </div>
                  <div class="info-content">
                    <span class="info-label">Colores Configurados</span>
                    <span class="info-value">{{ Object.keys(prestador.atributos.assets.colors || {}).length }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "./SideNav.vue";
import TopNavClean from "./TopNavClean.vue";
import Loader from "@/components/Loader.vue";
import { mapGetters } from "vuex";

export default {
  name: "ConfiguracionPrestador",
  components: {
    SideNav,
    TopNavClean,
    Loader
  },
  data() {
    return {
      isLoading: false,
      activeTab: 'config',
      showKeys: false,
      htmlViews: {},
      tabs: [
        { id: 'config', label: 'Configuraciones' },
        { id: 'assets', label: 'Assets' },
        { id: 'info', label: 'Información' }
      ]
    };
  },
  computed: {
    ...mapGetters(['prestador'])
  },
  mounted() {
    // Inicializar vistas HTML
    if (this.prestador?.atributos?.config) {
      Object.keys(this.prestador.atributos.config).forEach(key => {
        if (this.isHTML(this.prestador.atributos.config[key])) {
          this.$set(this.htmlViews, key, 'preview');
        }
      });
    }
  },
  methods: {
    isBoolean(value) {
      return value === 0 || value === 1;
    },
    isHTML(value) {
      if (typeof value !== 'string') return false;
      const htmlPattern = /<\/?[a-z][\s\S]*>/i;
      return htmlPattern.test(value);
    },
    formatLabel(key) {
      return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
    }
  }
};
</script>

<style scoped>
.column-left {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  z-index: 1000;
}

.column-right {
  background-color: #f8f9fa;
  padding-top: 0;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.main-container {
  padding: 24px;
  margin-top: 10px;
}

/* Page Header */
.page-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.page-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1rem;
  color: #6b7280;
  margin: 0;
}

/* Tabs */
.tabs-container {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  background: white;
  padding: 0.5rem;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.tab-button {
  padding: 0.625rem 1.25rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-button:hover {
  background: #f3f4f6;
  color: #374151;
}

.tab-button.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* Config Container */
.config-container {
  max-width: 100%;
}

.config-section {
  margin-bottom: 2rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.toggle-keys-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.toggle-keys-btn:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
}

.config-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

/* Colors Grid */
.colors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.color-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.color-display-large {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.color-preview {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid white;
}

.color-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.color-value {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  font-family: 'Monaco', 'Courier New', monospace;
}

.color-key {
  font-size: 0.75rem;
  color: #9ca3af;
  font-family: 'Monaco', 'Courier New', monospace;
}

/* Config Fields */
.config-fields {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.field-item {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.field-item:last-child {
  padding-bottom: 0;
  border-bottom: none;
}

.field-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.field-column {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.field-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.field-label {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1f2937;
}

.field-key {
  font-size: 0.75rem;
  color: #9ca3af;
  font-family: 'Monaco', 'Courier New', monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  display: inline-block;
  width: fit-content;
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 26px;
  flex-shrink: 0;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: not-allowed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  transition: 0.3s;
  border-radius: 26px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

input:checked + .toggle-slider:before {
  transform: translateX(22px);
}

/* HTML Editor */
.html-editor {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.editor-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.editor-tab {
  padding: 0.75rem 1.25rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 2px solid transparent;
}

.editor-tab:hover {
  color: #374151;
  background: #f3f4f6;
}

.editor-tab.active {
  color: #667eea;
  border-bottom-color: #667eea;
  background: white;
}

.editor-content {
  background: white;
}

.html-preview {
  padding: 1.5rem;
  min-height: 120px;
}

.html-code {
  padding: 1.5rem;
  margin: 0;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 0.8125rem;
  line-height: 1.6;
  color: #374151;
  background: #f9fafb;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* Badges */
.number-badge {
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  display: inline-block;
}

.array-badge,
.object-badge {
  padding: 0.375rem 0.75rem;
  background: #ede9fe;
  color: #7c3aed;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.75rem;
  display: inline-block;
  margin-bottom: 0.75rem;
}

/* Text Display */
.text-display {
  padding: 1rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #374151;
  font-size: 0.9375rem;
  line-height: 1.6;
}

/* JSON Preview */
.json-preview {
  padding: 1rem;
  margin: 0;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 0.8125rem;
  line-height: 1.6;
  color: #374151;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}

/* Array/Object Display */
.array-display,
.object-display {
  display: flex;
  flex-direction: column;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.info-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.2s;
}

.info-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.info-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  flex-shrink: 0;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-label {
  font-size: 0.8125rem;
  color: #6b7280;
  font-weight: 500;
}

.info-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

/* Responsive */
@media (max-width: 768px) {
  .column-left {
    display: none;
  }

  .column-right {
    padding-left: 0;
  }

  .main-container {
    padding: 1rem;
  }

  .page-header {
    padding: 1.5rem;
  }

  .page-icon {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .colors-grid,
  .info-grid {
    grid-template-columns: 1fr;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .toggle-keys-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>